const Moment = require("moment");

export default function humanizeDate(timestamp, format = null) {
  Moment.relativeTimeThreshold("s", 60);
  Moment.relativeTimeThreshold("m", 60);
  Moment.relativeTimeThreshold("h", 24);
  const utcTime = Moment.utc(timestamp);

  const relativeTime = utcTime.fromNow();

  const startOfDay = Moment().startOf("day");
  return formatTimeStamp(utcTime, relativeTime, startOfDay, format);
}

function formatTimeStamp(utcTime, relativeTime, startOfDay) {
  console.log("time-log : ", utcTime.utcOffset("+05:30").format("D MMM YYYY, h:mm A"));
  return (relativeTime = utcTime.utcOffset("+05:30").format("D MMM YYYY, h:mm A"));
}
